module.exports = __webpack_public_path__ + "img/share_to_fiends.c5504d5d.png";